<div>
  <div
    appThrottleClick
    (throttleClick)="navItemSelected()"
    [attr.data-testid]="navItem | navItemTestId"
    [class.active]="viewModel.isNavItemActive$ | async"
    [class.animating]="animating$ | async"
    [ngbTooltip]="collapsed ? navItem.name : null"
    [placement]="'right'"
    class="nav-item active bs-nav-item">
    <div class="nav-item-icon">
      <img [src]="navItem.iconSrc" alt="icon" class="nav-bar-icon" />
      <img [src]="navItem.iconFilledSrc" alt="icon-filled" class="nav-bar-icon-filled" />
    </div>
    <div *rxIf="!collapsed" class="nav-item-label" [class.multi-line-label]="viewModel.multiLineNavItem$ | async">
      {{ navItem.name }}
      <div *rxIf="viewModel.incompleteAccount$ | async" class="alert-indicator"></div>
    </div>
  </div>
</div>
